import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@mui/material";

interface ConfirmationDialogProps {
	open: boolean;
	title: string;
	message: string;
	confirmLabel?: string;
	cancelLabel?: string;
	onConfirm: () => void;
	onCancel: () => void;
}

export const ConfirmationDialog = ({
	open,
	title,
	message,
	confirmLabel = "CONTINUE",
	cancelLabel = "CANCEL",
	onConfirm,
	onCancel,
}: ConfirmationDialogProps) => (
	<Dialog open={open} onClose={onCancel} maxWidth="xs">
		<DialogTitle sx={{ fontWeight: 700, fontSize: 16 }}>{title}</DialogTitle>
		<DialogContent>
			<DialogContentText sx={{ fontSize: 14 }}>{message}</DialogContentText>
		</DialogContent>
		<DialogActions sx={{ px: 3, pb: 2 }}>
			<Button
				onClick={onCancel}
				variant="contained"
				sx={{
					backgroundColor: "#e0e0e0",
					color: "rgba(0,0,0,0.87)",
					"&:hover": { backgroundColor: "#d5d5d5" },
				}}
			>
				{cancelLabel}
			</Button>
			<Button onClick={onConfirm} variant="contained" color="primary">
				{confirmLabel}
			</Button>
		</DialogActions>
	</Dialog>
);
